<template>
  <section class="order-document-upload-modal">
    <v-btn
      v-if="document.uploadable"          
      icon   
      color="success"
      title="Upload Documento"
      @click.prevent.stop="openModal()"
    >
      <v-icon size="15">
        upload
      </v-icon>
    </v-btn> 
    
    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="500"
      persistent
    >    
      <v-card class="mb-0">
        <v-card-title class="app-card-title">
          {{ document.document_type.name }}
        </v-card-title>
        <v-card-text class="app-card-content">            
          <UploadFile
            v-model="file"
            :is-image="document.imageable"          
            @change="makeUpload($event)"
          />
          <section
            v-if="loading"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="success"
            />
            <span>Enviando arquivo ...</span>
          </section>
          <v-icon
            v-if="error"
            left
            color="error"
          >
            error
          </v-icon>{{ error }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            outlined
            color="error"
            @click="closeModal"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>    
    </v-dialog>
  </section>
</template>

<script>
  import UploadFile from '@/components/UploadFile';
  import DocumentService from '@/services/documento.service';

  export default {
    name: 'OrderDocumentUploadModal',
    
    components: { 
      UploadFile 
    },

    props: {
      order: {
        type: Object,
        required: true
      },
      document: {
        type: Object,
        required: true
      },
    },  

    data: () => ({
      modal: {
        show: false
      },
      file: null,
      error: null,
      loading: false,
    }),
    
    methods: {
      makeUpload(event) {
        const { target: { files } } = event;      
      
        const formData = new FormData();
        formData.append('file', files[0]);

        this.loading = true;
        this.error = null;

        DocumentService
          .uploadFile(this.order.id, this.document.id, formData)
          .subscribe(response => {
            this.loading = false;
            this.closeModal(true);
          }, error => {          
            const { message } = error.response.data;
            this.loading = false;
            this.error = message[0] || 'Erro ao enviar o arquivo';
          });
      },

      openModal() {
        this.modal.show = true;
      },

      closeModal(success = false) {
        this.modal.show = false;
        this.file = null;
        this.error = null;
        this.loading = false;
        this.$emit('close', { success });
      },
    },
  }
</script>